// extracted by mini-css-extract-plugin
export default {"PopularItemContainer":"PopularItemContainer_PopularItemContainer__C49Sr"};